<template>
  <div id="app" class="container">
    <p>
      FindAR is a searchable database of
      {{ store.state.allArticles.length }} articles pulled from ACM and IEEE
      databases since 2017. The articles have been categorized into {{store.state.midLevelTerms.length}} main
      topic areas. AREA members can search through this database and access
      relevant URL links to research, abstracts, and graphical information about
      AR enterprise research.
      <br/>
      <br/>
      Begin typing your term in the search field. As you type, suggested terms from the database will appear in a list. To complete your search, select one of the suggested terms from the list.
      <br/>
      <br/>
      Database last updated on 04/15/2021
    </p>
    <button
      v-if="store.history.length > 1"
      class="btn back-button"
      @click="store.loadPreviousSearch()"
    >
      Previous Search
    </button>
    <router-link to="/topics" tag="button" class="btn top-link back-to-results"
      >Explore all main topics</router-link
    >
    <vue-autosuggest
      ref="searchInput"
      v-model="store.state.lowLevelTerm"
      @selected="selectHandler"
      :inputProps="inputProps"
      :suggestions="getSuggestionsLowLevel()"
      :getSuggestionValue="s => s.item.label"
      :class="{ searchDisabled: store.state.showResultsTable }"
    >
      <template slot="after-input">
        <a
          class="clear-search-button"
          :for="inputProps.id"
          @click="resetSuggestions"
          >&#10006;</a
        >
      </template>
      <template slot-scope="{ suggestion }">
        <div>
          <span class="suggestion-item">{{ suggestion.item.label }}</span>
        </div>
      </template>
    </vue-autosuggest>
    <!-- THIS IS THE IMAGE FEATURE THAT IS HIDDEN WHEN TABLE IS DISPLAYED
    <template>
     <div 
      class="showImages"
       :class='{ hideImages: store.state.showResultsTable }'>
        <div class='data-plots-column'>
          <img class='data-plots-left' src="https://areadev.wpengine.com/wp-content/uploads/2021/02/mid-cooccur-bubble-top40.png">
        </div>
        <div class='data-plots-column'>
          <img class='data-plots-right' src="https://areadev.wpengine.com/wp-content/uploads/2021/02/frequency_feature_figure.png">
        </div>
    </div>
    </template>
    -->
    <div v-if="store.state.showResultsTable">
      <Articles :key="store.state.lowLevelTerm" />
    </div>
    <div v-if="store.state.selectedArticle">
      <Article :key="store.state.selectedArticle.Title" />
    </div>
  </div>
</template>

<script>
//Component to display list of articles
import Articles from "@/components/Articles";
//Component to display single article
import Article from "@/components/Article-Single";
//Autosuggest component.
//https://github.com/darrenjennings/vue-autosuggest
import { VueAutosuggest } from "vue-autosuggest";
//Import or global store used to hold variables and function used by multiple components.
import { store } from "@/store";

export default {
  name: "App",
  components: {
    Articles,
    VueAutosuggest,
    Article
  },
  data: function() {
    return {
      store,
      //Object passed to Vue Autsuggest component to initialize.
      inputProps: {
        id: "autosuggest__input",
        placeholder: "Search Term",
        class: "ddd",
        onInputChange: this.onInputChange
      }
    };
  },
  methods: {
    //When a user selects a term from the list of suggestions, use it to set the low/mid level term, show the results table and generate a list of articles associated with that term.
    selectHandler(item) {
      if (item) {
        store.state.lowLevelTerm = item.item.label;
        store.state.midLevelTerm = item.item.category;
        store.state.showResultsTable = true;
        store.getFilteredArticles();
      }
    },
    //Clear the users selection and suggestions.
    resetSuggestions() {
      store.state.lowLevelTerm = "";
      store.state.filteredArticles = [];
      store.state.midLevelTerm = "";
      store.state.showResultsTable = false;
      store.state.selectedArticle = null;
      store.state.searchLevel = null;
    },
    //Don't show anything if nothing has been typed.
    onInputChange(text) {
      if (text === "" || text === undefined) {
        return;
      }
    },
    //Checks the users input against our array of low level terms and returns possible matches.
    getSuggestionsLowLevel() {
      return [
        {
          data: this.store.state.lowLevelTerms
            .filter(item => {
              return (
                item.label
                  .toLowerCase()
                  .indexOf(this.store.state.lowLevelTerm.toLowerCase()) > -1
              );
            })
                // THIS MAKES SEARCH ITEMS ALPHABETIZED
            .sort((a, b) => (a.label > b.label) ? 1 : -1)
        }
      ];
    }
  },
  mounted() {
    //Used to manipulate the heading of the page in Wordpress.
    if (document.querySelector("#page .container h1.title").textContent)
      document.querySelector("#page .container h1.title").innerHTML =
        "<a href = '/search-tool/'>FindAR</a>";

    if (document.getElementById("currentLoggedInEmail"))
      store.userData.email = document.getElementById(
        "currentLoggedInEmail"
      ).value;
    if (document.getElementById("currentLoggedInUserID"))
      store.userData.id = document.getElementById(
        "currentLoggedInUserID"
      ).value;
  }
};
</script>

<style>
p {
  font-size: 16px;
}
h1.title {
  text-align: center;
}
#app {
  min-height: 500px;
  max-width: 100%;
  overflow: hidden;
}
#autosuggest {
  width: 350px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  height: 50px;
  margin-top: 50px;
}
#autosuggest__input {
  width: 340px;
  background-color: #f1f1f1;
  border: 1px solid transparent;
  background-color: #f1f1f1;
  padding: 10px;
  font-size: 16px;
  border-radius: 10em;
}
.autosuggest__results-item {
  cursor: pointer;
}
 ul[role="listbox"] {
  max-height: 230px;
  overflow-y: scroll;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  list-style: none;
  text-align: left;
  padding-left: 0;
  background-color:white;
}
.clear-search-button {
  position: absolute;
  font-size: 20px;
  cursor: pointer;
  right: 0%;
  top: 10px;
}
.searchDisabled input {
  pointer-events: none;
  opacity: 0.5;
}
.autosuggest__results .autosuggest__results-item:active,
.autosuggest__results .autosuggest__results-item:hover,
.autosuggest__results .autosuggest__results-item:focus,
.autosuggest__results-item--highlighted.autosuggest__results-item {
  background-color: #efefef;
}
.top-link {
  float: right;
}
.text-center {
  text-align: center;
}
.suggestion-item {
  font-family: "Lato", sans-serif;
  font-size: 20px;
  color: #0a3a4a;
  font-weight: 300;
  line-height: 17px;
  margin-bottom: 3px;
}
.autosuggest__results {
  border: 1px solid;
  padding: 5px;
}
.autosuggest__results {
  margin: 0;
  position: absolute;
  z-index: 10000001;
  width: 100%;
  border: 1px solid #e0e0e0;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  padding: 0;
  overflow-y: scroll;
  max-height: 230px;
}
/* This is used to style the items in the list but do not add a scroll property to this or it will cause a bug where the suggestions disappear when a user clicks on the scrollbar. 
Only add scroll to the .autosuggest__results. */
ul[role="listbox"] {
  list-style: none;
  padding-left: 20px !important;
}
.showImages{
  padding-top: 20px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
}
.hideImages {
  display: none;
}

.data-plots-column {
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
  flex: 1;
}

.data-plots-left {
  max-height: 400px;
  object-fit: contain;
}

.data-plots-right {
  max-height: 400px;
  object-fit: contain;
}
</style>
